import { FormType } from '../../form-types';

export const femaleHRTBeluga: FormType = {
  name: 'Female HRT Visit',

  questions: [
    {
      key: 'femaleHRTBeluga_sexAssignedAtBirth',
      next: {
        condition: {
          'femaleHRTBeluga_sexAssignedAtBirth.femaleHRTBeluga_sexAssignedAtBirth_male':
            true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_pregnancy'
      }
    },
    {
      key: 'femaleHRTBeluga_pregnancy',
      next: {
        condition: {
          'femaleHRTBeluga_pregnancy.femaleHRTBeluga_pregnancy_yes': true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_pregnancyConsent'
      }
    },
    {
      key: 'femaleHRTBeluga_pregnancyConsent',
      next: {
        condition: {
          'femaleHRTBeluga_pregnancyConsent.femaleHRTBeluga_pregnancyConsent_disagree':
            true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_pregnancyPossibility'
      }
    },
    {
      key: 'femaleHRTBeluga_pregnancyPossibility',
      next: {
        condition: {
          'femaleHRTBeluga_pregnancyPossibility.femaleHRTBeluga_pregnancyPossibility_yes':
            true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_breastfeeding'
      }
    },
    {
      key: 'femaleHRTBeluga_breastfeeding',
      next: {
        condition: {
          'femaleHRTBeluga_breastfeeding.femaleHRTBeluga_breastfeeding_yes':
            true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_menopauseSymptoms'
      }
    },

    {
      key: 'femaleHRTBeluga_menopauseSymptoms',
      next: {
        condition: {
          'femaleHRTBeluga_menopauseSymptoms.femaleHRTBeluga_menopauseSymptoms_yes':
            true
        },
        key: 'femaleHRTBeluga_symptomTypes',
        els: 'femaleHRTBeluga_ineligible'
      }
    },
    {
      key: 'femaleHRTBeluga_symptomTypes',
      next: {
        condition: {
          'femaleHRTBeluga_symptomTypes.femaleHRTBeluga_symptomTypes_other':
            true
        },
        key: 'femaleHRTBeluga_otherSymptoms',
        els: 'femaleHRTBeluga_symptomDuration'
      }
    },
    'femaleHRTBeluga_otherSymptoms',
    'femaleHRTBeluga_symptomDuration',
    {
      key: 'femaleHRTBeluga_oophorectomy',
      next: {
        condition: {
          'femaleHRTBeluga_oophorectomy.femaleHRTBeluga_oophorectomy_yes': true
        },
        key: 'femaleHRTBeluga_oophorectomyDetails',
        els: 'femaleHRTBeluga_hysterectomy'
      }
    },
    'femaleHRTBeluga_oophorectomyDetails',
    {
      key: 'femaleHRTBeluga_hysterectomy',
      next: {
        condition: {
          'femaleHRTBeluga_hysterectomy.femaleHRTBeluga_hysterectomy_yes': true
        },
        key: 'femaleHRTBeluga_hysterectomyDetails',
        els: 'femaleHRTBeluga_vaginalSymptoms'
      }
    },
    'femaleHRTBeluga_hysterectomyDetails',
    'femaleHRTBeluga_vaginalSymptoms',
    {
      key: 'femaleHRTBeluga_boneThinning',
      next: {
        condition: {
          'femaleHRTBeluga_boneThinning.femaleHRTBeluga_boneThinning_yes': true
        },
        key: 'femaleHRTBeluga_boneThinningDetails',
        els: 'femaleHRTBeluga_currentHRT'
      }
    },
    'femaleHRTBeluga_boneThinningDetails',
    {
      key: 'femaleHRTBeluga_currentHRT',
      next: {
        condition: {
          'femaleHRTBeluga_currentHRT.femaleHRTBeluga_currentHRT_yes': true
        },
        key: 'femaleHRTBeluga_currentHRTFormulation',
        els: 'femaleHRTBeluga_pastHRT'
      }
    },
    'femaleHRTBeluga_currentHRTFormulation',
    {
      key: 'femaleHRTBeluga_hrtSideEffects',
      next: {
        condition: {
          'femaleHRTBeluga_hrtSideEffects.femaleHRTBeluga_hrtSideEffects_yes':
            true
        },
        key: 'femaleHRTBeluga_hrtSideEffectsDetails',
        els: 'femaleHRTBeluga_pastHRT'
      }
    },
    'femaleHRTBeluga_hrtSideEffectsDetails',
    {
      key: 'femaleHRTBeluga_pastHRT',
      next: {
        condition: {
          'femaleHRTBeluga_pastHRT.femaleHRTBeluga_pastHRT_yes': true
        },
        key: 'femaleHRTBeluga_pastHRTDetails',
        els: 'femaleHRTBeluga_medicalHistory'
      }
    },
    'femaleHRTBeluga_pastHRTDetails',
    'femaleHRTBeluga_pastHRTSideEffects',
    {
      key: 'femaleHRTBeluga_medicalHistory',
      next: {
        condition: {
          'femaleHRTBeluga_medicalHistory.femaleHRTBeluga_medicalHistory_none':
            false
        },
        key: 'femaleHRTBeluga_medicalHistoryDetails',
        els: 'femaleHRTBeluga_abnormalBleeding'
      }
    },
    'femaleHRTBeluga_medicalHistoryDetails',
    {
      key: 'femaleHRTBeluga_abnormalBleeding',
      next: {
        condition: {
          'femaleHRTBeluga_abnormalBleeding.femaleHRTBeluga_abnormalBleeding_yes':
            true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_liverDisease'
      }
    },
    {
      key: 'femaleHRTBeluga_liverDisease',
      next: {
        condition: {
          'femaleHRTBeluga_liverDisease.femaleHRTBeluga_liverDisease_yes': true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_bloodClots'
      }
    },
    {
      key: 'femaleHRTBeluga_bloodClots',
      next: {
        condition: {
          'femaleHRTBeluga_bloodClots.femaleHRTBeluga_bloodClots_yes': true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_hormoneSensitiveCancer'
      }
    },
    'femaleHRTBeluga_hormoneSensitiveCancer',
    {
      key: 'femaleHRTBeluga_familyCancerHistory',
      next: {
        condition: {
          'femaleHRTBeluga_familyCancerHistory.femaleHRTBeluga_familyCancerHistory_yes':
            true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_cardiovascularHistory'
      }
    },
    'femaleHRTBeluga_cardiovascularHistory',

    'femaleHRTBeluga_nicotineUse',
    {
      key: 'femaleHRTBeluga_medications',
      next: {
        condition: {
          'femaleHRTBeluga_medications.femaleHRTBeluga_medications_none': true
        },
        key: 'femaleHRTBeluga_bloodPressure',
        els: 'femaleHRTBeluga_ineligible'
      }
    },
    {
      key: 'femaleHRTBeluga_bloodPressure',
      next: {
        condition: {
          'femaleHRTBeluga_bloodPressure.femaleHRTBeluga_bloodPressure_high':
            true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_adhesiveAllergy'
      }
    },
    'femaleHRTBeluga_adhesiveAllergy',
    'femaleHRTBeluga_additionalInfo',
    {
      key: 'femaleHRTBeluga_hrtConsent',
      next: {
        condition: {
          'femaleHRTBeluga_hrtConsent.femaleHRTBeluga_hrtConsent_disagree': true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_truthfulnessConsent'
      }
    },
    {
      key: 'femaleHRTBeluga_truthfulnessConsent',
      next: {
        condition: {
          'femaleHRTBeluga_truthfulnessConsent.femaleHRTBeluga_truthfulnessConsent_disagree':
            true
        },
        key: 'femaleHRTBeluga_ineligible',
        els: 'femaleHRTBeluga_complete'
      }
    },
    'femaleHRTBeluga_ineligible',
    'femaleHRTBeluga_complete'
  ]
};
